<template>
  <thanks-page v-if="thanks" :thanks="thanks" />
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { BookingThanks } from '../schemas'

@Component({
  setup: () => {
    return {
      formStore: useFormStore(),
    }
  },
})
class ThanksMain extends Vue {
  formStore: ReturnType<typeof useFormStore>

  @Prop()
  thanks: BookingThanks

  mounted() {
    this.markViewed()
    this.clearTransientFormData()
  }

  private clearTransientFormData() {
    // Clear booking-session specific data now that booking is complete
    this.formStore.clearTransientFields()
  }

  private markViewed() {
    const prettyId = this.prettyId
    if (!prettyId) {
      return
    }

    const url = `/_/fallback/booking/viewed/${prettyId}/`

    // Send empty POST request
    $fetch(url, {
      method: 'POST',
      body: {},
    }).catch(() => {
      // Silently fail if tracking fails
    })
  }

  private get prettyId(): string {
    return this.thanks?.prettyId || ''
  }
}

export default toNative(ThanksMain)
</script>
